<template>
  <div class="page1">
    <el-carousel class="carousel">
      <el-carousel-item v-for="item in imgs" :key="item">
        <img :src="item" width="100%" />
      </el-carousel-item>
    </el-carousel>
    <br />
    <br />
    <div class="font_container">
      会社案内
      <br />
      <br />
      <br />

      Agsivoは、豊なコミュニケーション社会の発展に貢献することを企業理念とし、重要な社会使命として、高品質な商品とサービスを提供すると同時に、さまざまな分野で活躍しております。
      販売及び輸出入事業、企画、開発、制作事業、広告業及びホテル、旅館など観光施設の経営事業などの経営範囲です。この度は、電気通信事業を開始しました。
      皆様がより便利に使用することには微力ながら貢献し、よりよい社会づくりの一翼を担っていけるよう、社員一同、努力してまいります。
      <br />
      <br />

      <div class="date">2020年4月</div>
      <div class="date">代表取引役 黄河</div>
    </div>
  </div>
</template>
<script>
import img1 from '../../public/settings/images/scrollBg1.jpg'
import img2 from '../../public/settings/images/scrollBg2.jpg'

export default {
  data() {
    return {
      img1,
      img2,
      imgs: [img1, img2],
    }
  },
}
</script>
<style lang="scss" scoped>
.carousel {
  // transform: translateY(50%);
}
.page1 {
  height: 100%;
  background: #fff;
  border-radius: 25px;
  padding: 40px;
  .font_container {
    text-align: left;
    font-weight: bold;
    line-height: 30px;

    .date {
      text-align: right;
      & + .date {
        margin-top: 10px;
      }
    }
  }
}
</style>
